import CreateButton from 'components/buttons/CreateButton';
import Card from 'components/card';
import { downloadAllCustomers } from 'interfaces/customer';

const ExportCard = (props: {
    name: string;
    description: string;
    commingSoon?: boolean;
    onClick?: () => void;
}) => {
    const { name, description, commingSoon = false, onClick } = props;

    return (
        <Card extra={'relative w-full mt-4 px-2 py-6 border'}>
            {/* Badge */}
            <div className="absolute top-3 right-3 bg-green-600/80 text-white text-xs px-2 py-1 rounded-lg">
                {'CSV'}
            </div>
            {/* Header */}
            <div className="w-full px-1">
                <h4 className="text-xl font-medium">{name}</h4>
                <p className="mt-2 text-xs">{description}</p>
            </div>
            <div className="mt-4 flex justify-center">
                {commingSoon ? (
                    <button
                        className={`text-sm px-5 h-10 linear flex items-center justify-center rounded-xl bg-[#518dd1] py-3 font-medium text-white w-full cursor-not-allowed`}
                    >
                        Bientôt disponible
                    </button>
                ) : (
                    <CreateButton
                        value="Exporter"
                        extra="text-sm px-5 h-10 w-full mb-0 bg-toola-500"
                        onClick={onClick}
                    />
                    
                )}
            </div>
        </Card>
    );
};

const ExportList = () => {


    const downloadExportAllCustomers = async () => {
        try {
            const result = await downloadAllCustomers();
            if (!result) return;
        } catch (error) {
            console.error('Erreur export clients:', error);
        }
    };

    return (
        <div className="mt-2">
            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                <ExportCard
                    name="Achats par client"
                    description="Quantité et total HT de produits commandés par un client sur une période."
                    //onClick={downloadExportByCustomer}
                    commingSoon={true}
                />
                <ExportCard
                    name="Mes produits"
                    description="Exportez la totalité de vos produits sur un fichier CSV."
                    commingSoon={true}
                />
                <ExportCard
                    name="Mes clients"
                    description="Exportez la totalité de vos clients sur un fichier CSV."
                    //commingSoon={true}
                    onClick={downloadExportAllCustomers} 
                />
            </div>
        </div>
    );
};

export default ExportList;
